import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ModernPageShell from "components/ModernPageShell";

export default function PrivacyPolicy() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  return (
    <ModernPageShell title={t('privacy_policy')}>
      {settings && settings.privacyContent ?
            <p style={{whiteSpace:'pre-line'}}>{settings.privacyContent}</p>
            :
            <>
            <p >{t('privacy_policy_para1')}</p>
            <p >{t('privacy_policy_para2')}</p>
            <p >{t('privacy_policy_para3')}</p>

            <p >
            <strong>{t('privacy_policy_heading_info')}</strong>
            </p>
            <p >
                {t('privacy_policy_info_para1')}
            </p>
            <ul style={{direction:isRTL === 'rtl'?'rtl':'ltr'}}>
            <li>
                {t('privacy_policy_info_list1')}
            </li>
            <li>
                {t('privacy_policy_info_list2')}
            </li>
            <li>
               {t('privacy_policy_info_list3')}
            </li>
            <li>
               {t('privacy_policy_info_list4')}
            </li>
            </ul>
            <p >
                {t('privacy_policy_info_para2')}
            </p>
            <p >
                {t('privacy_policy_info_para3')}
            </p>
            <p >
                {t('privacy_policy_info_para4')}
            </p>
            <ul style={{direction:isRTL === 'rtl'?'rtl':'ltr'}}>
                <li>
                    {t('privacy_policy_info_list5')}
                </li>
                <li>
                    {t('privacy_policy_info_list6')}
                </li>
                <li>
                    {t('privacy_policy_info_list7')}
                </li>
                
              </ul> 
            <p >
                {t('privacy_policy_info_para5')}
            </p>
          <p >
              <strong>{t('privacy_policy_heading_log')}</strong>
          </p>
          <p >
            {t('privacy_policy_log_para1')}
          </p>
          <p >
              <strong>{t('privacy_policy_heading_cookie')}</strong>
          </p>
          <p >
              {t('privacy_policy_cookie_para1')}
          </p>
          <p >
              {t('privacy_policy_cookie_para2')}
          </p>
          <p >
              <strong>{t('privacy_policy_heading_service')}</strong>
          </p>
          <p >
              {t('privacy_policy_service_para1')}
          </p>
          <ul style={{direction:isRTL === 'rtl'?'rtl':'ltr'}}>
              <li>
                  {t('privacy_policy_service_list1')}
              </li>
              <li>
                 {t('privacy_policy_service_list2')}
              </li>
              <li>
                  {t('privacy_policy_service_list3')}
              </li>
              <li>
                  {t('privacy_policy_service_list4')}
              </li>
            </ul>
          <p >
             {t('privacy_policy_service_para2')}
          </p>
          <p >
              <strong>{t('privacy_policy_heading_security')}</strong>
          </p>
          <p >
              {t('privacy_policy_security_para1')}
          </p>
          <p >
              <strong>{t('privacy_policy_heading_link')}</strong>
          </p>
          <p >
              {t('privacy_policy_link_para1')}
          </p>
          <p >
              <strong>{t('privacy_policy_heading_children')}</strong>
          </p>
          <p >
              {t('privacy_policy_children_para1')}
          </p>
          <p >
              <strong>{t('delete_account_lebel').toUpperCase()}</strong>
          </p>
          <p >
              {t('delete_account_msg')}
          </p>
          <p >
            {t('delete_account_subheading')}
          </p>
            <ul style={{direction:isRTL === 'rtl'?'rtl':'ltr'}}>
                <li>
                {t('delete_account_para1')}
                </li>
                <li>
                {t('delete_account_para2')}
                </li>
            </ul>
          <p >
              <strong>{t('privacy_policy_heading_change_privacy')}</strong>
          </p>
          <p >
              {t('privacy_policy_change_privacy_para1')}
          </p>
          <p >
              {t('privacy_policy_change_privacy_para2')}
          </p>
          <p >
              <strong>{t('privacy_policy_heading_contact')}</strong>
          </p>
          <p >
          {t('privacy_policy_contact_para1')} 
          {settings && settings.contact_email?
            <a href={"mailto:" + settings.contact_email}><strong>{settings.contact_email}</strong></a>
          :null}
          </p>
          </>
          }
    </ModernPageShell>
  );
}
